import { CommonPaginator, usePaginated } from './usePaginated'
import { Voucher } from 'depoto-core'
import { useCallback, useMemo } from 'react'
import { removeEmptyProperties } from '../'
import { useCore } from '../../hooks'

type SqlDateFilter = {
  left_date: string
  right_date: string
}

export type VoucherFilters = Partial<{
  companies: number[]
  name: string
  code: string
  externalId: string
  discountType: string
  enabled: boolean
  isPayment: boolean
  isValid: boolean
  isUsed: boolean
  validDate?: SqlDateFilter
  created?: SqlDateFilter
}>

interface Params {
  filters?: VoucherFilters
  sort?: string
  direction?: string
  schema?: any
}

export function usePaginatedVouchers(params: Params = {}) {
  const { filters, schema = { id: null }, sort = 'code', direction = 'ASC' } = params
  const { core } = useCore()

  const serverFilters = useMemo(
    () =>
      removeEmptyProperties(filters || {}),
    [filters],
  )

  const fetchVouchers = useCallback(
    async (page: number) => {
      const params: any = removeEmptyProperties({
        direction,
        filters: serverFilters,
        page,
        sort: sort,
      })

      return (await core.services.voucher.getList(params, schema)) as {
        items: Voucher[]
        paginator: CommonPaginator
      }
    },
    [core.services.voucher, serverFilters, sort],
  )

  const {
    isLastPage,
    loadMore,
    loading,
    refresh,
    items: vouchers,
    totalCount,
  } = usePaginated<Voucher>({
    queryKey: ['vouchers', filters, sort, direction],
    fetchItems: fetchVouchers,
  })

  return {
    isLastPage,
    loadMore,
    loading,
    vouchers,
    refresh,
    totalCount,
  }
}
